<template>
  <div class="end-game-screen">
    <template v-if="timesPlayed === showCovveAdAtTimesPlayed">
      <div class="header part">
        <div class="title">
          Time to stop messing about!
        </div>
        <!-- <div class="subtitle">
        <span class="highlighted-text">{{ score }}pts</span>
      </div> -->
      </div>
      <div class="part">
        <p>
          Update your dated address book. <br />
          Covve is your modern contacts app. Simple, smart and free :)
        </p>
      </div>

      <div class="part download-covve">
        <p style="font-size: 1.125rem">
          <span class="highlighted-text">Get Covve!</span>
        </p>
        <p style="text-align:center;margin-top: 20px">
          <a
            class="img-a-button"
            href="https://covve.com/"
            target="_blank"
            @click="trackDownloadEvent()"
          >
            <img src="@/assets/btn-download.png" alt="Get Covve" />
          </a>
        </p>
      </div>
    </template>

    <template v-else>
      <div class="header part">
        <div class="title">You scored {{ score }} pts</div>
        <!-- <div class="subtitle">
        <span class="highlighted-text">{{ score }}pts</span>
      </div> -->
      </div>
      <div class="part">
        <p>
          Love the game?<br />
          Share with your friends and get extra points!
        </p>
      </div>

      <ShareBox :score="score" :currentUser="currentUser"></ShareBox>
    </template>

    <div class="part play-again">
      <a @click="handlePlayAgain"
        >Play Again! <i class="fas fa-arrow-right"></i
      ></a>
    </div>
  </div>
</template>

<script>
import ShareBox from "@/components/shared/ShareBox";
import { trackEvent } from "../analytics";
export default {
  components: { ShareBox },
  props: ["score", "currentUser", "timesPlayed"],
  data() {
    return {
      copied: false,
      showCovveAdAtTimesPlayed: 4
    };
  },
  mounted() {
    if (this.timesPlayed === this.showCovveAdAtTimesPlayed) {
      trackEvent("saw covve advert");
    }
  },
  methods: {
    trackDownloadEvent() {
      trackEvent("clicked to download covve");
    },
    handlePlayAgain() {
      this.$emit("play-again");
    }
  }
};
</script>

<style lang="scss">
.end-game-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  height: 100%;
  padding: 0 10px;
  .part {
    margin: 15px 0;
    width: 100%;
  }
  .header {
    .title {
      font-size: 1.325rem;
    }
    .subtitle {
      margin-top: 5px;
    }
  }

  .download-covve {
    margin: 20px 0 30px 0;
  }

  .play-again {
    box-sizing: border-box;
    margin: 0px;
    padding: 0 10px;
    text-align: right;
    font-size: 0.625rem;
    a {
      cursor: pointer;
    }
  }

  p {
    font-size: 0.625rem;
  }
}

@media (max-width: 768px) {
  .social-buttons {
    display: flex;
    flex-direction: column;
  }
  .play-again {
    margin-bottom: 7px !important;
  }
}

@media (max-width: 320px) {
  .end-game-screen {
    .header {
      .title {
        font-size: 1.2rem;
      }
    }
  }
}
</style>
